import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { IDonation } from "../types";


interface donationsData {
  donations: IDonation[];
  
}
const MonthlyDonationsChart: React.FC<donationsData> = ({ donations}) => {

    const [chartData, setChartData] = useState<{ 
        month: string; 
        donation_amount: number; 
        available_amount: number; 
        service_fee: number; 
    }[]>([])

    useEffect(() => {

        const generateChart =()=>{

            const data = donations;
                
            // Define the type for monthlyData
            const monthlyData: Record<string, { month: string; donation_amount: number; available_amount: number; service_fee: number }> = {};
            
            data.forEach(({ date, donation_amount, available_amount, service_fee }) => {
                const month = new Date(date).toLocaleString('default', { month: 'short', year: 'numeric' });
                if (!monthlyData[month]) {
                    monthlyData[month] = { month, donation_amount: 0, available_amount: 0, service_fee: 0 };
                }
                monthlyData[month].donation_amount += parseInt(donation_amount);
                monthlyData[month].available_amount += available_amount;
                monthlyData[month].service_fee += service_fee;
            });
            
            setChartData(Object.values(monthlyData));

        }
      
        generateChart();
    }, []);

 

    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="donation_amount" fill="#8884d8" name="Total Donations" />
                <Bar dataKey="available_amount" fill="#82ca9d" name="Net Donations" />
                <Bar dataKey="service_income" fill="#ffc658" name="Income from Services" />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default MonthlyDonationsChart;
